/**
 * @generated SignedSource<<fdf3df29699124c4b31b81f7c31b5a29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "FondySignResponse",
    "kind": "LinkedField",
    "name": "fondySign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signature",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "orderId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reservationData",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseSignPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseSignPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "268301a6f5e77125a34a08ad49b7c3d2",
    "id": null,
    "metadata": {},
    "name": "ImpulseSignPaymentCheckoutPagesMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseSignPaymentCheckoutPagesMutation(\n  $request: FondySignRequestInput\n) {\n  fondySign(request: $request) {\n    signature\n    orderId\n    reservationData\n  }\n}\n"
  }
};
})();

node.hash = "530db69ad06d30beaab9e8c49aa5b419";

module.exports = node;
